import React, { FC, StrictMode, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { FqdnList } from './containers/FqdnList'
import { FqdnView } from './containers/FqdnView'
import { FqdnCreate } from './containers/FqdnCreate'
import { FqdnEdit } from './containers/FqdnEdit'
import { SYSTEM_CONFIGURATION_ROUTE, NETWORK, FQDN } from '../../constants';

const Fqdn: FC = () => (
  <StrictMode>
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}`} component={FqdnList} />
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}/view`} component={FqdnView} />
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}/edit`} component={FqdnEdit} />
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}/create`} component={FqdnCreate} />
    </Fragment>
  </StrictMode>
)

export default Fqdn;
